import { Component, OnInit, OnDestroy, Input, SimpleChanges, OnChanges } from '@angular/core';
import { Subscription, lastValueFrom } from 'rxjs';
import { Utility } from '../utils/app-utils';
import { Alarm } from 'src/models/alarm.model';
import { AlarmService } from '../services/alarm.service';
import { HttpClient } from "@angular/common/http";
import { ApiConstants } from '../constants/api-constants';
import { VideoStreamService } from '../services/video-stream.service';
import { DashboardComponent } from '../dashboard/dashboard.component';

@Component({
	selector: 'app-thermal-feeds',
	templateUrl: './thermal-feeds.component.html',
	styleUrls: ['./thermal-feeds.component.scss']
})

export class ThermalFeedsComponent implements OnInit, OnDestroy, OnChanges {
	alarm: Alarm;
	public videoURL: string;
	public scShootURL: string;
	isImg: boolean = false;
	isVid: boolean = false;
	utility = Utility;
	@Input() alarmId: string;

	constructor(private alarmService: AlarmService, public http: HttpClient,
		public videoStreamService: VideoStreamService,
		private dashboardComponent: DashboardComponent) { }

	ngOnInit() {
		if (this.alarmId) {
			this.fetchAlarm(this.alarmId);
		};
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.alarmId && !changes.alarmId.isFirstChange()) {
			this.fetchAlarm(changes.alarmId.currentValue);
		}
	}

	ngOnDestroy() {
		//
	}

	async fetchAlarm(alarmId: string) {
		try {
			const response: any = await lastValueFrom(this.http.get<any>(ApiConstants.URL_ALARMS + "/alarm/" + alarmId, { params: {} }));
			if (response.success === true) {
				if (response.data.aiVideo === "") {
					this.videoURL = "noVID"
					this.isVid = false;
				} else {
					this.videoURL = response.data.aiVideo;
					this.isVid = true;
				}

				if (response.data.aiPhoto === "") {
					this.scShootURL = "noIMG"
					this.isImg = false;
				} else {
					this.scShootURL = response.data.aiPhoto;
					this.isImg = true;
				}
			}
		} catch (err) {
		}
	}


	async updateAlarm(alarmOption: any) {
		try {
			const response: any = await lastValueFrom(this.http.get<any>(ApiConstants.URL_ALARMS + "/alarm/" + this.alarmService.selectedAlarm.id, { params: { ...alarmOption } }));
			if (response.success === true && response.data.aiVideo !== "") {
				this.videoURL = response.data.aiVideo;
				this.isVid = true;
			}
		} catch (err) {
		}
	}

	showFullScreenImage() {
		if (!this.isImg || !this.scShootURL || this.scShootURL === 'noIMG') {
			return;
		}

		this.dashboardComponent.showOverlayWidget('fullscreen-video', {
			type: 'photo',
			url: this.scShootURL
		});
	}

	showFullScreenVideo() {
		if (!this.isVid || !this.videoURL || this.videoURL === 'noVID') {
			return;
		}

		this.dashboardComponent.showOverlayWidget('fullscreen-video', {
			type: 'video',
			url: this.videoURL
		});
	}

}
